import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DropdownMenuId } from '~/types/dropdown-menu'
import { RootState } from '~/redux/store'

interface DropdownMenuState {
  menuToClose: DropdownMenuId | null
  menuToOpen: DropdownMenuId | null
}

const initialState: DropdownMenuState = {
  menuToClose: null,
  menuToOpen: null,
}

const slice = createSlice({
  name: 'dropdown-menu',
  initialState,
  reducers: {
    clearMenuToClose: (state) => ({
      ...state,
      menuToClose: null,
    }),

    clearMenuToOpen: (state) => ({
      ...state,
      menuToOpen: null,
    }),

    shouldCloseDropdownMenu: (state, action: PayloadAction<DropdownMenuId>) => ({
      ...state,
      menuToClose: action.payload,
    }),

    shouldOpenDropdownMenu: (state, action: PayloadAction<DropdownMenuId>) => ({
      ...state,
      menuToOpen: action.payload,
    }),
  },
})

export const selectDropdownMenuToClose = (state: RootState): DropdownMenuState['menuToClose'] => {
  return state.dropdownMenu.menuToClose
}

export const selectDropdownMenuToOpen = (state: RootState): DropdownMenuState['menuToOpen'] => {
  return state.dropdownMenu.menuToOpen
}

export const {
  clearMenuToClose: clearMenuToCloseActionCreator,
  clearMenuToOpen: clearMenuToOpenActionCreator,
  shouldCloseDropdownMenu: shouldCloseDropdownMenuActionCreator,
  shouldOpenDropdownMenu: shouldOpenDropdownMenuActionCreator,
} = slice.actions

export default slice.reducer
